import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=3463d511&scoped=true"
import script from "./offers.vue?vue&type=script&lang=js"
export * from "./offers.vue?vue&type=script&lang=js"
import style0 from "./offers.vue?vue&type=style&index=0&id=3463d511&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463d511",
  null
  
)

export default component.exports